import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/TarasMelnychenko/subs.vtt';
import poster from '@/static/assets/reviews/TarasMelnychenko/video.jpg';

export const TarasMelnychenko: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Taras',
  videoUrl: `${ASSETS_URL}/pet/TarasMelnychenko_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
